// Module
var code = "<script>let $ctrl</script> <div class=\"molecule-panel-show-all\"> <molecule-link-with-icon icon-name=\"{{ $ctrl.iconName }}\" icon-name-path=\"$ctrl.iconNamePath\" route=\"{{ $ctrl.route }}\">{{ $ctrl.linkText }}</molecule-link-with-icon> </div> ";
// Exports
module.exports = code;